/* ConvertMate 24-oct-2026 · PDP Best Seller · variantes, galería, cantidad, agregar al carrito y barra fija.
   Sin dependencias. Usa el carrito del tema (cart-drawer o cart-notification de Dawn) y, si no existe, va a /cart. */
(function () {
  if (window.CMPdpLoaded) return;
  window.CMPdpLoaded = true;

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var re = /\{\{\s*(\w+)\s*\}\}/;
    format = format || '${{amount}}';
    function delim(n, prec, thou, dec) {
      thou = thou === undefined ? ',' : thou;
      dec = dec === undefined ? '.' : dec;
      if (isNaN(n) || n == null) return '0';
      n = (n / 100.0).toFixed(prec);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thou);
      var c = parts[1] ? dec + parts[1] : '';
      return dollars + c;
    }
    var m = format.match(re);
    var v = '';
    switch (m ? m[1] : 'amount') {
      case 'amount': v = delim(cents, 2); break;
      case 'amount_no_decimals': v = delim(cents, 0, '.'); break; /* COP: $650.000 */
      case 'amount_with_comma_separator': v = delim(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = delim(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = delim(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': v = delim(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': v = delim(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': v = delim(cents, 2, ' ', '.'); break;
      default: v = delim(cents, 2);
    }
    return format.replace(re, v);
  }

  function findSectionTarget(anchor) {
    if (!anchor) return null;
    return document.getElementById(anchor) ||
      document.querySelector('[id$="__' + anchor + '"]') ||
      document.querySelector('[id*="' + anchor + '"]');
  }

  function PDP(root) {
    this.root = root;
    var data = root.querySelector('[data-cm-variants]');
    this.cfg = JSON.parse(data.textContent);
    this.form = root.querySelector('[data-cm-form]');
    this.idInput = root.querySelector('[data-cm-variant-input]');
    var id = parseInt(this.idInput.value, 10);
    this.variant = this.cfg.variants.find(function (v) { return v.id === id; }) || this.cfg.variants[0];
    this.qty = 1;
    this.sticky = document.querySelector('[data-cm-sticky]');
    this.bindOptions();
    this.bindGallery();
    this.bindQty(root.querySelector('[data-cm-qty]'));
    if (this.sticky) this.bindQty(this.sticky.querySelector('[data-cm-qty]'));
    this.bindAtc();
    this.bindReviews();
    this.bindSticky();
    this.render(false);
  }

  PDP.prototype.bindOptions = function () {
    var self = this;
    this.root.querySelectorAll('[data-cm-opt-input]').forEach(function (input) {
      input.addEventListener('change', function () { self.onOptionChange(); });
    });
  };

  PDP.prototype.onOptionChange = function () {
    var selected = [];
    this.root.querySelectorAll('[data-cm-option]').forEach(function (fs) {
      var c = fs.querySelector('[data-cm-opt-input]:checked');
      selected.push(c ? c.value : null);
      var lbl = fs.querySelector('[data-cm-option-val]');
      if (lbl && c) lbl.textContent = c.value;
    });
    var match = this.cfg.variants.find(function (v) {
      return v.options.every(function (o, i) { return o === selected[i]; });
    });
    this.variant = match || null;
    this.render(true);
  };

  PDP.prototype.maxQty = function () {
    var v = this.variant;
    if (v && v.deny && typeof v.inv === 'number' && v.inv > 0) return v.inv;
    return 999;
  };

  PDP.prototype.setQty = function (n) {
    n = parseInt(n, 10);
    if (isNaN(n) || n < 1) n = 1;
    n = Math.min(n, this.maxQty());
    this.qty = n;
    document.querySelectorAll('[data-cm-qty-input]').forEach(function (i) { i.value = n; });
    this.renderTotals();
  };

  PDP.prototype.bindQty = function (wrap) {
    if (!wrap) return;
    var self = this;
    var input = wrap.querySelector('[data-cm-qty-input]');
    wrap.querySelector('[data-cm-qty-minus]').addEventListener('click', function () { self.setQty(self.qty - 1); });
    wrap.querySelector('[data-cm-qty-plus]').addEventListener('click', function () { self.setQty(self.qty + 1); });
    input.addEventListener('change', function () { self.setQty(input.value); });
  };

  PDP.prototype.renderTotals = function () {
    var v = this.variant, cfg = this.cfg;
    var total = v ? formatMoney(v.price * this.qty, cfg.moneyFormat) : '';
    document.querySelectorAll('[data-cm-atc-label]').forEach(function (el) {
      var isSticky = !!el.closest('[data-cm-sticky]');
      if (!v) { el.textContent = cfg.unavailableLabel; return; }
      if (!v.available) { el.textContent = cfg.soldoutLabel; return; }
      var base = isSticky ? (el.getAttribute('data-label') || cfg.atcLabel) : cfg.atcLabel;
      el.textContent = (!isSticky && cfg.atcShowPrice) ? base + ' — ' + total : base;
    });
    if (this.sticky) {
      var t = this.sticky.querySelector('[data-cm-sticky-total]');
      if (t) t.textContent = total;
    }
  };

  PDP.prototype.render = function (changed) {
    var v = this.variant, cfg = this.cfg, root = this.root;
    var atcs = document.querySelectorAll('[data-cm-atc]');
    atcs.forEach(function (b) { b.disabled = !v || !v.available; });
    if (!v) { this.renderTotals(); return; }

    this.idInput.value = v.id;
    var price = root.querySelector('[data-cm-price]');
    var compare = root.querySelector('[data-cm-compare]');
    var save = root.querySelector('[data-cm-save]');
    price.textContent = formatMoney(v.price, cfg.moneyFormat);
    if (v.compare > v.price) {
      compare.hidden = false;
      compare.innerHTML = '<span class="cm-visually-hidden">Antes</span>' + formatMoney(v.compare, cfg.moneyFormat);
      var saving = v.compare - v.price;
      var pct = Math.round(saving * 100 / v.compare);
      save.textContent = cfg.savingsText.replace('[porcentaje]', pct).replace('[ahorro]', formatMoney(saving, cfg.moneyFormat));
      save.hidden = false;
    } else { compare.hidden = true; save.hidden = true; }

    var sc = root.querySelector('[data-cm-scarcity]');
    if (sc) {
      var show = cfg.scarcityOn && v.available && typeof v.inv === 'number' && v.inv > 0 && v.inv <= cfg.scarcityMax;
      sc.hidden = !show;
      if (show) sc.querySelector('[data-cm-scarcity-txt]').textContent =
        cfg.scarcityText.replace('[cantidad]', v.inv).replace('[color]', v.title.toLowerCase());
    }

    document.querySelectorAll('[data-cm-qty-input]').forEach(function (i) {
      if (v.deny && typeof v.inv === 'number') i.max = v.inv; else i.removeAttribute('max');
    });
    if (this.qty > this.maxQty()) this.qty = this.maxQty();

    if (v.img) {
      var main = root.querySelector('[data-cm-slide="0"] img');
      if (main) {
        main.removeAttribute('srcset');
        main.src = v.img;
        main.alt = v.alt || '';
        var base = v.img;
        main.srcset = [550, 720, 900, 1100].map(function (w) {
          return base.replace(/width=\d+/, 'width=' + w) + ' ' + w + 'w';
        }).join(', ');
      }
      var th = root.querySelector('[data-cm-thumb="0"] img');
      if (th && v.thumb) th.src = v.thumb;
    }

    if (this.sticky) {
      var sv = this.sticky.querySelector('[data-cm-sticky-variant]');
      if (sv) sv.textContent = (sv.getAttribute('data-prefix') || '') + v.title;
      var si = this.sticky.querySelector('[data-cm-sticky-img]');
      if (si && v.sticky) si.src = v.sticky;
    }

    this.renderTotals();

    if (changed) {
      this.goTo(0);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
      document.dispatchEvent(new CustomEvent('cm:pdp:variant', { detail: { variant: v } }));
    }
  };

  /* Galería */
  PDP.prototype.bindGallery = function () {
    var self = this;
    this.track = this.root.querySelector('[data-cm-track]');
    this.thumbs = Array.prototype.slice.call(this.root.querySelectorAll('[data-cm-thumb]'));
    this.thumbs.forEach(function (t) {
      t.addEventListener('click', function () { self.goTo(parseInt(t.getAttribute('data-cm-thumb'), 10)); });
    });
    if (!this.track) return;
    var raf;
    this.track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(self.track.scrollLeft / self.track.clientWidth);
        self.setActiveThumb(i);
      });
    }, { passive: true });
    this.track.addEventListener('keydown', function (e) {
      var i = Math.round(self.track.scrollLeft / self.track.clientWidth);
      if (e.key === 'ArrowRight') { e.preventDefault(); self.goTo(i + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); self.goTo(i - 1); }
    });
  };
  PDP.prototype.goTo = function (i) {
    if (!this.track) return;
    var n = this.track.children.length;
    i = Math.max(0, Math.min(n - 1, i));
    this.track.scrollTo({ left: i * this.track.clientWidth, behavior: 'smooth' });
    this.setActiveThumb(i);
  };
  PDP.prototype.setActiveThumb = function (i) {
    this.thumbs.forEach(function (t, k) {
      var on = k === i;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
  };

  /* Agregar al carrito */
  PDP.prototype.bindAtc = function () {
    var self = this;
    this.form.addEventListener('submit', function (e) {
      e.preventDefault();
      self.addToCart(self.root.querySelector('[data-cm-main-atc]'));
    });
    if (this.sticky) {
      var sb = this.sticky.querySelector('[data-cm-atc]');
      if (sb) sb.addEventListener('click', function (e) { e.preventDefault(); self.addToCart(sb); });
    }
  };

  PDP.prototype.addToCart = function (btn) {
    var self = this, v = this.variant;
    if (!v || !v.available || (btn && btn.getAttribute('aria-busy') === 'true')) return;
    var err = this.root.querySelector('[data-cm-error]');
    if (err) err.hidden = true;
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var fd = new FormData();
    fd.append('id', v.id);
    fd.append('quantity', this.qty);
    if (cart && typeof cart.getSectionsToRender === 'function') {
      fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      fd.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }
    document.querySelectorAll('[data-cm-atc]').forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
    var url = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
    fetch(url, { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' } })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          if (err) { err.textContent = res.description || res.message || self.cfg.errorText; err.hidden = false; }
          return;
        }
        document.dispatchEvent(new CustomEvent('cm:cart:added', { detail: res }));
        if (window.publish && window.PUB_SUB_EVENTS) {
          try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'cm-pdp', productVariantId: v.id, cartData: res }); } catch (e) {}
        }
        if (cart && typeof cart.renderContents === 'function') {
          cart.classList.remove('is-empty');
          cart.renderContents(res);
          var drawerItems = document.querySelector('cart-drawer-items');
          if (drawerItems) drawerItems.classList.remove('is-empty');
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () {
        if (err) { err.textContent = self.cfg.errorText; err.hidden = false; }
      })
      .finally(function () {
        document.querySelectorAll('[data-cm-atc]').forEach(function (b) { b.removeAttribute('aria-busy'); });
      });
  };

  PDP.prototype.bindReviews = function () {
    this.root.querySelectorAll('[data-cm-scroll]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var t = findSectionTarget(a.getAttribute('data-cm-scroll'));
        if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    });
  };

  /* Barra fija: aparece cuando el botón principal ya quedó arriba */
  PDP.prototype.bindSticky = function () {
    var st = this.sticky;
    var main = this.root.querySelector('[data-cm-main-atc]');
    if (!st || !main || !('IntersectionObserver' in window)) return;
    var setVis = function (on) {
      st.classList.toggle('is-visible', on);
      st.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (on) st.removeAttribute('inert'); else st.setAttribute('inert', '');
      document.documentElement.classList.toggle('cm-sticky-on', on);
    };
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      setVis(!e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(main);
  };

  function init() {
    document.querySelectorAll('[data-cm-pdp]').forEach(function (root) {
      if (!root.__cmPdp) root.__cmPdp = new PDP(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { window.CMPdpLoaded && init(); });
})();
